import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import { parse as t, translateX as e, translateY as n, scaleX as i, scaleY as r, multiply as o } from "rematrix";
import a from "prop-types";
import s, { createContext as p, Component as l, Children as c, cloneElement as u } from "react";

var f = function f(t) {
  return "number" == typeof t;
},
    d = function d(t) {
  return "[object Object]" === Object.prototype.toString.call(t);
},
    h = function h(t) {
  return Array.prototype.slice.apply(t);
};

function g(t) {
  for (var e = [], n = arguments.length - 1; n-- > 0;) {
    e[n] = arguments[n + 1];
  }

  return e.forEach(function (e) {
    if (e) for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }
  }), t;
}

var m,
    v = function v(t, e, n) {
  return t + (e - t) * n;
},
    y = {
  noWobble: {
    stiffness: 200,
    damping: 26
  },
  gentle: {
    stiffness: 120,
    damping: 14
  },
  veryGentle: {
    stiffness: 130,
    damping: 17
  },
  wobbly: {
    stiffness: 180,
    damping: 12
  },
  stiff: {
    stiffness: 260,
    damping: 26
  }
},
    S = function S(t) {
  return d(t) ? t : Object.keys(y).indexOf(t) > -1 ? y[t] : {};
};

"undefined" != typeof window && (m = window.requestAnimationFrame);

var _ = m = m || function (t) {
  window.setTimeout(t, 1e3 / 60);
},
    E = Date.now(),
    C = "object" == typeof performance && "function" == typeof performance.now ? function () {
  return performance.now();
} : function () {
  return Date.now() - E;
};

function A(t, e) {
  var n = t.indexOf(e);
  -1 !== n && t.splice(n, 1);
}

var b = function b() {};

b.prototype.run = function () {
  var t = this;

  _(function () {
    t.springSystem.loop(C());
  });
};

var I = function I() {
  this.position = 0, this.velocity = 0;
},
    O = 0,
    x = function x(t) {
  this._id = "s" + O++, this._springSystem = t, this.listeners = [], this._startValue = 0, this._currentState = new I(), this._displacementFromRestThreshold = .001, this._endValue = 0, this._overshootClampingEnabled = !1, this._previousState = new I(), this._restSpeedThreshold = .001, this._tempState = new I(), this._timeAccumulator = 0, this._wasAtRest = !0, this._cachedSpringConfig = {};
};

x.prototype.getId = function () {
  return this._id;
}, x.prototype.destroy = function () {
  this.listeners = [], this._springSystem.deregisterSpring(this);
}, x.prototype.setSpringConfig = function (t) {
  return this._springConfig = t, this;
}, x.prototype.getCurrentValue = function () {
  return this._currentState.position;
}, x.prototype.getDisplacementDistanceForState = function (t) {
  return Math.abs(this._endValue - t.position);
}, x.prototype.setEndValue = function (t) {
  if (t === this._endValue) return this;
  if (this.prevEndValue = t, this._endValue === t && this.isAtRest()) return this;
  this._startValue = this.getCurrentValue(), this._endValue = t, this._springSystem.activateSpring(this.getId());

  for (var e = 0, n = this.listeners.length; e < n; e++) {
    var i = this.listeners[e].onSpringEndStateChange;
    i && i(this);
  }

  return this;
}, x.prototype.setVelocity = function (t) {
  return t === this._currentState.velocity ? this : (this._currentState.velocity = t, this._springSystem.activateSpring(this.getId()), this);
}, x.prototype.setCurrentValue = function (t) {
  this._startValue = t, this._currentState.position = t;

  for (var e = 0, n = this.listeners.length; e < n; e++) {
    var i = this.listeners[e];
    i.onSpringUpdate && i.onSpringUpdate(this);
  }

  return this;
}, x.prototype.setAtRest = function () {
  return this._endValue = this._currentState.position, this._tempState.position = this._currentState.position, this._currentState.velocity = 0, this;
}, x.prototype.setOvershootClampingEnabled = function (t) {
  return this._overshootClampingEnabled = t, this;
}, x.prototype.isOvershooting = function () {
  var t = this._startValue,
      e = this._endValue;
  return this._springConfig.tension > 0 && (t < e && this.getCurrentValue() > e || t > e && this.getCurrentValue() < e);
}, x.prototype.advance = function (t, e) {
  var n = this.isAtRest();

  if (!n || !this._wasAtRest) {
    var i = e;
    e > .064 && (i = .064), this._timeAccumulator += i;

    for (var r, o, a, s, p, l, c = this._springConfig.tension, u = this._springConfig.friction, f = this._currentState.position, d = this._currentState.velocity, h = this._tempState.position, g = this._tempState.velocity; this._timeAccumulator >= .001;) {
      this._timeAccumulator -= .001, this._timeAccumulator < .001 && (this._previousState.position = f, this._previousState.velocity = d), o = c * (this._endValue - h) - u * d, s = c * (this._endValue - (h = f + .001 * (r = d) * .5)) - u * (g = d + .001 * o * .5), l = c * (this._endValue - (h = f + .001 * (a = g) * .5)) - u * (g = d + .001 * s * .5), h = f + .001 * (p = g), f += 1 / 6 * (r + 2 * (a + p) + (g = d + .001 * l)) * .001, d += 1 / 6 * (o + 2 * (s + l) + (c * (this._endValue - h) - u * g)) * .001;
    }

    this._tempState.position = h, this._tempState.velocity = g, this._currentState.position = f, this._currentState.velocity = d, this._timeAccumulator > 0 && this._interpolate(this._timeAccumulator / .001), (this.isAtRest() || this._overshootClampingEnabled && this.isOvershooting()) && (this._springConfig.tension > 0 ? (this._startValue = this._endValue, this._currentState.position = this._endValue) : (this._endValue = this._currentState.position, this._startValue = this._endValue), this.setVelocity(0), n = !0);
    var m = !1;
    this._wasAtRest && (this._wasAtRest = !1, m = !0);
    var v = !1;
    n && (this._wasAtRest = !0, v = !0), this.notifyPositionUpdated(m, v);
  }
}, x.prototype.notifyPositionUpdated = function (t, e) {
  var n = this;
  this.listeners.filter(Boolean).forEach(function (i) {
    t && i.onSpringActivate && !n._onActivateCalled && (i.onSpringActivate(n), n._onActivateCalled = !0), i.onSpringUpdate && i.onSpringUpdate(n), e && i.onSpringAtRest && i.onSpringAtRest(n);
  });
}, x.prototype.systemShouldAdvance = function () {
  return !this.isAtRest() || !this.wasAtRest();
}, x.prototype.wasAtRest = function () {
  return this._wasAtRest;
}, x.prototype.isAtRest = function () {
  return Math.abs(this._currentState.velocity) < this._restSpeedThreshold && (this.getDisplacementDistanceForState(this._currentState) <= this._displacementFromRestThreshold || 0 === this._springConfig.tension);
}, x.prototype._interpolate = function (t) {
  this._currentState.position = this._currentState.position * t + this._previousState.position * (1 - t), this._currentState.velocity = this._currentState.velocity * t + this._previousState.velocity * (1 - t);
}, x.prototype.addListener = function (t) {
  return this.listeners.push(t), this;
}, x.prototype.addOneTimeListener = function (t) {
  var e = this;
  return Object.keys(t).forEach(function (n) {
    var i;
    t[n] = (i = t[n], function () {
      for (var n = [], r = arguments.length; r--;) {
        n[r] = arguments[r];
      }

      i.apply(void 0, n), e.removeListener(t);
    });
  }), this.listeners.push(t), this;
}, x.prototype.removeListener = function (t) {
  return A(this.listeners, t), this;
};

var w = function w(t) {
  this.looper = t || new b(), this.looper.springSystem = this, this.listeners = [], this._activeSprings = [], this._idleSpringIndices = [], this._isIdle = !0, this._lastTimeMillis = -1, this._springRegistry = {};
};

w.prototype.createSpring = function (t, e) {
  return this.createSpringWithConfig({
    tension: t,
    friction: e
  });
}, w.prototype.createSpringWithConfig = function (t) {
  var e = new x(this);
  return this.registerSpring(e), e.setSpringConfig(t), e;
}, w.prototype.getIsIdle = function () {
  return this._isIdle;
}, w.prototype.registerSpring = function (t) {
  this._springRegistry[t.getId()] = t;
}, w.prototype.deregisterSpring = function (t) {
  A(this._activeSprings, t), delete this._springRegistry[t.getId()];
}, w.prototype.advance = function (t, e) {
  for (var n = this; this._idleSpringIndices.length > 0;) {
    this._idleSpringIndices.pop();
  }

  for (this._activeSprings.filter(Boolean).forEach(function (i) {
    i.systemShouldAdvance() ? i.advance(t / 1e3, e / 1e3) : n._idleSpringIndices.push(n._activeSprings.indexOf(i));
  }); this._idleSpringIndices.length > 0;) {
    var i = this._idleSpringIndices.pop();

    i >= 0 && this._activeSprings.splice(i, 1);
  }
}, w.prototype.loop = function (t) {
  var e;
  -1 === this._lastTimeMillis && (this._lastTimeMillis = t - 1);
  var n = t - this._lastTimeMillis;
  this._lastTimeMillis = t;
  var i = 0,
      r = this.listeners.length;

  for (i = 0; i < r; i++) {
    (e = this.listeners[i]).onBeforeIntegrate && e.onBeforeIntegrate(this);
  }

  for (this.advance(t, n), 0 === this._activeSprings.length && (this._isIdle = !0, this._lastTimeMillis = -1), i = 0; i < r; i++) {
    (e = this.listeners[i]).onAfterIntegrate && e.onAfterIntegrate(this);
  }

  this._isIdle || this.looper.run();
}, w.prototype.activateSpring = function (t) {
  var e = this._springRegistry[t];
  -1 === this._activeSprings.indexOf(e) && this._activeSprings.push(e), this.getIsIdle() && (this._isIdle = !1, this.looper.run());
};

var U = new w(),
    V = function V(t) {
  var e = t.springConfig,
      n = e.overshootClamping,
      i = t.getOnUpdateFunc,
      r = t.onAnimationEnd,
      o = t.onSpringActivate,
      a = U.createSpring(e.stiffness, e.damping);
  a.setOvershootClampingEnabled(!!n);
  var s = {
    onSpringActivate: o,
    onSpringAtRest: function onSpringAtRest() {
      a.destroy(), r();
    },
    onSpringUpdate: i({
      spring: a,
      onAnimationEnd: r
    })
  };
  return a.addListener(s), a;
},
    F = function F(t) {
  var e = V(t);
  return e.setEndValue(1), e;
},
    P = function P(t, e) {
  if (void 0 === e && (e = {}), t && t.length) {
    e.reverse && t.reverse();
    var n,
        i = "number" != typeof (n = e.speed) ? 1.1 : 1 + Math.min(Math.max(5 * n, 0), 5),
        r = 1 / Math.max(Math.min(t.length, 100), 10),
        o = t.map(function (t, e) {
      var n = t.getOnUpdateFunc;
      return t.getOnUpdateFunc = function (t) {
        var a = n(t);
        return function (t) {
          var n = t.getCurrentValue();
          (n = n < .01 ? 0 : n > .99 ? 1 : n) >= r && o[e + 1] && o[e + 1](Math.max(Math.min(n * i, 1), 0)), a(t);
        };
      }, t;
    }).map(function (t) {
      var e = V(t);
      if (e) return e.setEndValue.bind(e);
    }).filter(Boolean);
    o[0] && o[0](1);
  }
},
    M = function M(t) {
  return [0, 1, 4, 5, 12, 13].map(function (e) {
    return t[e];
  });
},
    R = function R(t) {
  return t.top < window.innerHeight && t.bottom > 0 && t.left < window.innerWidth && t.right > 0;
},
    k = function k(t, e) {
  var n;
  return g(t, ((n = {})[e[0]] = e[1], n));
},
    D = function D(t, e) {
  return h(e ? document.querySelectorAll('[data-portal-key="' + e + '"]') : t.querySelectorAll("[data-flip-id]"));
},
    j = function j(t) {
  return t.map(function (t) {
    return [t, t.getBoundingClientRect()];
  });
},
    T = new w(),
    K = function K(t) {
  var e = t.values,
      n = t.onUpdate,
      i = t.delay;
  void 0 === i && (i = 0);
  var r = t.onComplete,
      o = g({}, y.noWobble, S(t.config)),
      a = o.overshootClamping,
      s = T.createSpring(o.stiffness, o.damping);
  return s.setOvershootClampingEnabled(!!a), s.addListener({
    onSpringAtRest: function onSpringAtRest(t) {
      r && r(), t.destroy();
    },
    onSpringUpdate: function onSpringUpdate(t) {
      var i = t.getCurrentValue();
      if (!e) return n(i);
      var r = Object.keys(e).map(function (t) {
        return [t, v(e[t][0], e[t][1], i)];
      }).reduce(function (t, e) {
        var n;
        return Object.assign(t, ((n = {})[e[0]] = e[1], n));
      }, {});
      n(r);
    }
  }), i ? setTimeout(function () {
    s.setEndValue(1);
  }, i) : s.setEndValue(1), s;
},
    B = p({}),
    q = p("portal"),
    W = function (a) {
  function p() {
    a.apply(this, arguments), this.inProgressAnimations = {}, this.flipCallbacks = {}, this.el = void 0;
  }

  return a && (p.__proto__ = a), (p.prototype = Object.create(a && a.prototype)).constructor = p, p.prototype.getSnapshotBeforeUpdate = function (t) {
    return t.flipKey !== this.props.flipKey && this.el ? function (t) {
      var e = t.element,
          n = t.flipCallbacks;
      void 0 === n && (n = {});
      var i = t.inProgressAnimations;
      void 0 === i && (i = {});
      var r = D(e, t.portalKey),
          o = h(e.querySelectorAll("[data-inverse-flip-id]")),
          a = {},
          s = [],
          p = {};
      r.filter(function (t) {
        return n && n[t.dataset.flipId] && n[t.dataset.flipId].onExit;
      }).forEach(function (t) {
        var e = t.parentNode;

        if (t.closest) {
          var n = t.closest("[data-exit-container]");
          n && (e = n);
        }

        var i = s.findIndex(function (t) {
          return t[0] === e;
        });
        -1 === i && (s.push([e, e.getBoundingClientRect()]), i = s.length - 1), a[t.dataset.flipId] = s[i][1], p[t.dataset.flipId] = e;
      });
      var l = j(r),
          c = l.map(function (t) {
        var e = t[0],
            i = t[1],
            r = {};

        if (n && n[e.dataset.flipId] && n[e.dataset.flipId].onExit) {
          var o = a[e.dataset.flipId];
          g(r, {
            element: e,
            parent: p[e.dataset.flipId],
            childPosition: {
              top: i.top - o.top,
              left: i.left - o.left,
              width: i.width,
              height: i.height
            }
          });
        }

        return [e.dataset.flipId, {
          rect: i,
          opacity: parseFloat(window.getComputedStyle(e).opacity || "1"),
          domDataForExitAnimations: r
        }];
      }).reduce(k, {});
      return function (t, e) {
        Object.keys(t).forEach(function (e) {
          t[e].destroy && t[e].destroy(), t[e].onAnimationEnd && t[e].onAnimationEnd(!0), delete t[e];
        }), e.forEach(function (t) {
          t.style.transform = "", t.style.opacity = "";
        });
      }(i, r.concat(o)), {
        flippedElementPositions: c,
        cachedOrderedFlipIds: l.map(function (t) {
          return t[0].dataset.flipId;
        })
      };
    }({
      element: this.el,
      flipCallbacks: this.flipCallbacks,
      inProgressAnimations: this.inProgressAnimations,
      portalKey: this.props.portalKey
    }) : null;
  }, p.prototype.componentDidUpdate = function (a, s, p) {
    this.props.flipKey !== a.flipKey && this.el && function (a) {
      var s = a.cachedOrderedFlipIds;
      void 0 === s && (s = []);
      var p = a.inProgressAnimations;
      void 0 === p && (p = {});
      var l = a.flippedElementPositionsBeforeUpdate;
      void 0 === l && (l = {});
      var c = a.flipCallbacks;
      void 0 === c && (c = {});
      var u = a.containerEl,
          d = a.applyTransformOrigin,
          m = a.spring,
          _ = a.debug,
          E = a.portalKey,
          C = a.staggerConfig;
      void 0 === C && (C = {});
      var A = a.decisionData;
      void 0 === A && (A = {});

      var b = a.handleEnterUpdateDelete,
          I = a.onComplete,
          O = a.onStart,
          x = function (t) {
        return j(D(t.element, t.portalKey)).map(function (t) {
          var e = t[0],
              n = t[1],
              i = window.getComputedStyle(e);
          return [e.dataset.flipId, {
            element: e,
            rect: n,
            opacity: parseFloat(i.opacity),
            transform: i.transform
          }];
        }).reduce(k, {});
      }({
        element: u,
        portalKey: E
      }),
          w = function (t) {
        var e = t.containerEl,
            n = t.portalKey;
        return n ? function (t) {
          return function (e) {
            return h(document.querySelectorAll('[data-portal-key="' + t + '"]' + e));
          };
        }(n) : e ? function (t) {
          var e = Math.random().toFixed(5);
          return t.dataset.flipperId = e, function (n) {
            return h(t.querySelectorAll('[data-flipper-id="' + e + '"] ' + n));
          };
        }(e) : function () {
          return [];
        };
      }({
        containerEl: u,
        portalKey: E
      }),
          U = function (t) {
        return function (e) {
          return t('[data-flip-id="' + e + '"]')[0];
        };
      }(w),
          V = function V(t) {
        return l[t] && x[t];
      },
          T = Object.keys(l).concat(Object.keys(x)).filter(function (t) {
        return !V(t);
      }),
          K = {
        flipCallbacks: c,
        getElement: U,
        flippedElementPositionsBeforeUpdate: l,
        flippedElementPositionsAfterUpdate: x,
        inProgressAnimations: p,
        decisionData: A
      },
          B = function (t) {
        var e,
            n = t.unflippedIds,
            i = t.flipCallbacks,
            r = t.getElement,
            o = t.flippedElementPositionsBeforeUpdate,
            a = t.flippedElementPositionsAfterUpdate,
            s = t.inProgressAnimations,
            p = t.decisionData,
            l = n.filter(function (t) {
          return a[t];
        }).filter(function (t) {
          return i[t] && i[t].onAppear;
        }),
            c = n.filter(function (t) {
          return o[t] && i[t] && i[t].onExit;
        }),
            u = new Promise(function (t) {
          e = t;
        }),
            f = [],
            d = 0,
            h = c.map(function (t, n) {
          var r = o[t].domDataForExitAnimations,
              a = r.element,
              l = r.parent,
              c = r.childPosition,
              u = c.top,
              h = c.left,
              g = c.width,
              m = c.height;
          "static" === getComputedStyle(l).position && (l.style.position = "relative"), a.style.transform = "matrix(1, 0, 0, 1, 0, 0)", a.style.position = "absolute", a.style.top = u + "px", a.style.left = h + "px", a.style.height = m + "px", a.style.width = g + "px";
          var v = f.filter(function (t) {
            return t[0] === l;
          })[0];
          v || (v = [l, document.createDocumentFragment()], f.push(v)), v[1].appendChild(a), d += 1;

          var y = function y() {
            try {
              l.removeChild(a);
            } catch (t) {} finally {
              0 == (d -= 1) && e();
            }
          };

          return s[t] = {
            stop: y
          }, function () {
            return i[t].onExit(a, n, y, p);
          };
        });
        return f.forEach(function (t) {
          t[0].appendChild(t[1]);
        }), h.length || e(), {
          hideEnteringElements: function hideEnteringElements() {
            l.forEach(function (t) {
              var e = r(t);
              e && (e.style.opacity = "0");
            });
          },
          animateEnteringElements: function animateEnteringElements() {
            l.forEach(function (t, e) {
              var n = r(t);
              n && i[t].onAppear(n, e, p);
            });
          },
          animateExitingElements: function animateExitingElements() {
            return h.forEach(function (t) {
              return t();
            }), u;
          }
        };
      }(g({}, K, {
        unflippedIds: T
      })),
          q = B.hideEnteringElements,
          W = B.animateEnteringElements,
          N = B.animateExitingElements,
          L = g({}, K, {
        containerEl: u,
        flippedIds: s.filter(V),
        applyTransformOrigin: d,
        spring: m,
        debug: _,
        staggerConfig: C,
        scopedSelector: w,
        onComplete: I
      });

      O && O(u, A);

      var X = function (a) {
        var s = L.flippedIds,
            p = L.flipCallbacks,
            l = L.inProgressAnimations,
            c = L.flippedElementPositionsBeforeUpdate,
            u = L.flippedElementPositionsAfterUpdate,
            d = L.applyTransformOrigin,
            m = L.spring,
            _ = L.getElement,
            E = L.debug,
            C = L.staggerConfig;
        void 0 === C && (C = {});
        var A = L.decisionData;
        void 0 === A && (A = {});
        var b,
            I = L.onComplete,
            O = L.containerEl,
            x = new Promise(function (t) {
          b = t;
        });
        if (I && x.then(function () {
          return I(O, A);
        }), !s.length) return function () {
          return b([]), x;
        };

        var w,
            U = [],
            V = _(s[0]),
            k = V ? V.ownerDocument.querySelector("body") : document.querySelector("body");

        w = s.reduce(function (t, e) {
          return t[e] = (t[e] || 0) + 1, t;
        }, {}), Object.keys(w).filter(function (t) {
          return w[t] > 1;
        });
        var D = s.map(function (a) {
          var s = c[a].rect,
              _ = u[a].rect,
              E = c[a].opacity,
              C = u[a].opacity,
              I = _.width < 1 || _.height < 1,
              O = u[a].element;
          if (!R(s) && !R(_)) return !1;
          if (!O) return !1;

          var x = JSON.parse(O.dataset.flipConfig),
              w = function (t) {
            void 0 === t && (t = {});
            var e = t.flippedSpring;
            return g({}, y.noWobble, S(t.flipperSpring), S(e));
          }({
            flipperSpring: m,
            flippedSpring: x.spring
          }),
              V = !0 === x.stagger ? "default" : x.stagger,
              F = {
            element: O,
            id: a,
            stagger: V,
            springConfig: w
          };

          if (p[a] && p[a].shouldFlip && !p[a].shouldFlip(A.previous, A.current)) return !1;
          var P = Math.abs(s.left - _.left) + Math.abs(s.top - _.top),
              j = Math.abs(s.width - _.width) + Math.abs(s.height - _.height),
              T = Math.abs(C - E);
          if (P < .5 && j < .5 && T < .01) return !1;
          var K = t(u[a].transform),
              B = {
            matrix: K
          },
              q = {
            matrix: []
          },
              W = [K];
          x.translate && (W.push(e(s.left - _.left)), W.push(n(s.top - _.top))), x.scale && (W.push(i(Math.max(s.width, 1) / Math.max(_.width, 1))), W.push(r(Math.max(s.height, 1) / Math.max(_.height, 1)))), x.opacity && (q.opacity = E, B.opacity = C);
          var N = [];

          if (!p[a] || !p[a].shouldInvert || p[a].shouldInvert(A.previous, A.current)) {
            var L = function (t, e) {
              return h(t.querySelectorAll('[data-inverse-flip-id="' + e + '"]'));
            }(O, a);

            N = L.map(function (t) {
              return [t, JSON.parse(t.dataset.flipConfig)];
            });
          }

          q.matrix = M(W.reduce(o)), B.matrix = M(B.matrix);

          var X,
              Y = function (t) {
            var e = t.element,
                n = t.invertedChildren,
                i = t.body;
            return function (t) {
              var r = t.matrix,
                  o = t.opacity,
                  a = t.forceMinVals;

              if (f(o) && (e.style.opacity = o + ""), a && (e.style.minHeight = "1px", e.style.minWidth = "1px"), r) {
                var s = function (t) {
                  return "matrix(" + t.join(", ") + ")";
                }(r);

                e.style.transform = s, n && function (t) {
                  var e = t.matrix,
                      n = t.body;
                  t.invertedChildren.forEach(function (t) {
                    var i = t[0],
                        r = t[1];

                    if (n.contains(i)) {
                      var o = e[0],
                          a = e[3],
                          s = e[5],
                          p = {
                        translateX: 0,
                        translateY: 0,
                        scaleX: 1,
                        scaleY: 1
                      },
                          l = "";
                      r.translate && (p.translateX = -e[4] / o, p.translateY = -s / a, l += "translate(" + p.translateX + "px, " + p.translateY + "px)"), r.scale && (p.scaleX = 1 / o, p.scaleY = 1 / a, l += " scale(" + p.scaleX + ", " + p.scaleY + ")"), i.style.transform = l;
                    }
                  });
                }({
                  invertedChildren: n,
                  matrix: r,
                  body: i
                });
              }
            };
          }({
            element: O,
            invertedChildren: N,
            body: k
          });

          if (p[a] && p[a].onComplete) {
            var H = p[a].onComplete;

            X = function X() {
              return H(O, A);
            };
          }

          var J = f(q.opacity) && f(B.opacity) && q.opacity !== B.opacity,
              z = !1;
          return g({}, F, {
            stagger: V,
            springConfig: w,
            getOnUpdateFunc: function getOnUpdateFunc(t) {
              var e = t.spring,
                  n = t.onAnimationEnd;
              return l[a] = {
                destroy: e.destroy.bind(e),
                onAnimationEnd: n
              }, function (t) {
                p[a] && p[a].onSpringUpdate && p[a].onSpringUpdate(t.getCurrentValue()), z || (z = !0, p[a] && p[a].onStart && p[a].onStart(O, A));
                var e = t.getCurrentValue();

                if (k.contains(O)) {
                  var n = {
                    matrix: []
                  };
                  n.matrix = q.matrix.map(function (t, n) {
                    return v(t, B.matrix[n], e);
                  }), J && (n.opacity = v(q.opacity, B.opacity, e)), Y(n);
                } else t.destroy();
              };
            },
            initializeFlip: function initializeFlip() {
              Y({
                matrix: q.matrix,
                opacity: J ? q.opacity : void 0,
                forceMinVals: I
              }), p[a] && p[a].onStartImmediate && p[a].onStartImmediate(O, A), x.transformOrigin ? O.style.transformOrigin = x.transformOrigin : d && (O.style.transformOrigin = "0 0"), N.forEach(function (t) {
                var e = t[0],
                    n = t[1];
                n.transformOrigin ? e.style.transformOrigin = n.transformOrigin : d && (e.style.transformOrigin = "0 0");
              });
            },
            onAnimationEnd: function onAnimationEnd(t) {
              delete l[a], "function" == typeof X && X(), O.style.transform = "", N.forEach(function (t) {
                t[0].style.transform = "";
              }), I && O && (O.style.minHeight = "", O.style.minWidth = ""), t || (U.push(a), U.length >= D.length && b(U));
            },
            delayUntil: x.delayUntil
          });
        }).filter(Boolean);
        if (D.forEach(function (t) {
          return (0, t.initializeFlip)();
        }), E) return function () {};
        var j = D.filter(function (t) {
          return t.delayUntil && (e = t.delayUntil, D.filter(function (t) {
            return t.id === e;
          }).length);
          var e;
        }),
            T = {},
            K = {},
            B = {};
        j.forEach(function (t) {
          t.stagger ? (B[t.stagger] = !0, K[t.delayUntil] ? K[t.delayUntil].push(t.stagger) : K[t.delayUntil] = [t.stagger]) : T[t.delayUntil] ? T[t.delayUntil].push(t) : T[t.delayUntil] = [t];
        });
        var q = D.filter(function (t) {
          return t.stagger;
        }).reduce(function (t, e) {
          return t[e.stagger] ? t[e.stagger].push(e) : t[e.stagger] = [e], t;
        }, {}),
            W = D.filter(function (t) {
          return -1 === j.indexOf(t);
        });
        return W.forEach(function (t) {
          t.onSpringActivate = function () {
            T[t.id] && T[t.id].forEach(F), K[t.id] && Object.keys(K[t.id].reduce(function (t, e) {
              var n;
              return g(t, ((n = {})[e] = !0, n));
            }, {})).forEach(function (t) {
              P(q[t], C[t]);
            });
          };
        }), function () {
          return D.length || b([]), W.filter(function (t) {
            return !t.stagger;
          }).forEach(F), Object.keys(q).forEach(function (t) {
            B[t] || P(q[t], C[t]);
          }), x;
        };
      }();

      b ? b({
        hideEnteringElements: q,
        animateEnteringElements: W,
        animateExitingElements: N,
        animateFlippedElements: X
      }) : (q(), N().then(W), X());
    }({
      flippedElementPositionsBeforeUpdate: p.flippedElementPositions,
      cachedOrderedFlipIds: p.cachedOrderedFlipIds,
      containerEl: this.el,
      inProgressAnimations: this.inProgressAnimations,
      flipCallbacks: this.flipCallbacks,
      applyTransformOrigin: this.props.applyTransformOrigin,
      spring: this.props.spring,
      debug: this.props.debug,
      portalKey: this.props.portalKey,
      staggerConfig: this.props.staggerConfig,
      handleEnterUpdateDelete: this.props.handleEnterUpdateDelete,
      decisionData: {
        previous: a.decisionData,
        current: this.props.decisionData
      },
      onComplete: this.props.onComplete,
      onStart: this.props.onStart
    });
  }, p.prototype.render = function () {
    var t = this,
        e = this.props,
        n = e.portalKey,
        i = s.createElement(B.Provider, {
      value: this.flipCallbacks
    }, s.createElement(e.element, {
      className: e.className,
      ref: function ref(e) {
        return t.el = e;
      }
    }, this.props.children));
    return n && (i = s.createElement(q.Provider, {
      value: n
    }, i)), i;
  }, p;
}(l);

function N(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && -1 === e.indexOf(i) && (n[i] = t[i]);
  }

  return n;
}

W.defaultProps = {
  applyTransformOrigin: !0,
  element: "div"
};

var L = function L(t) {
  var e = t.children,
      n = t.flipId,
      i = t.inverseFlipId,
      r = t.portalKey,
      o = N(t, ["children", "flipId", "inverseFlipId", "portalKey"]),
      a = e,
      s = function (t) {
    return "function" == typeof t;
  }(a);

  if (!s) try {
    a = c.only(e);
  } catch (t) {
    throw new Error("Each Flipped component must wrap a single child");
  }
  o.scale || o.translate || o.opacity || g(o, {
    translate: !0,
    scale: !0,
    opacity: !0
  });
  var p = {};
  return p["data-flip-config"] = JSON.stringify(o), n ? p["data-flip-id"] = String(n) : i && (p["data-inverse-flip-id"] = String(i)), r && (p["data-portal-key"] = r), s ? a(p) : u(a, p);
},
    X = function X(t) {
  var e = t.children,
      n = t.flipId,
      i = t.shouldFlip,
      r = t.shouldInvert,
      o = t.onAppear,
      a = t.onStart,
      p = t.onStartImmediate,
      l = t.onComplete,
      c = t.onExit,
      u = t.onSpringUpdate,
      f = N(t, ["children", "flipId", "shouldFlip", "shouldInvert", "onAppear", "onStart", "onStartImmediate", "onComplete", "onExit", "onSpringUpdate"]);
  return e ? f.inverseFlipId ? s.createElement(L, Object.assign({}, f), e) : s.createElement(q.Consumer, null, function (t) {
    return s.createElement(B.Consumer, null, function (h) {
      return d(h) && n && (h[n] = {
        shouldFlip: i,
        shouldInvert: r,
        onAppear: o,
        onStart: a,
        onStartImmediate: p,
        onComplete: l,
        onExit: c,
        onSpringUpdate: u
      }), s.createElement(L, Object.assign({
        flipId: n
      }, f, {
        portalKey: t
      }), e);
    });
  }) : null;
};

X.displayName = "Flipped";

var Y = function Y(t) {
  var e;
  return u(t.children, ((e = {})["data-exit-container"] = !0, e));
};

export { W as Flipper, X as Flipped, Y as ExitContainer, K as spring };